import gql from 'graphql-tag'

export default gql`mutation ycmdChatRoomClearUnread($room_id: ID!) {
    ycmdChatRoomClearUnread(room_id: $room_id) 
    {
        status
	  }
}`
